import { injectable } from 'inversify';
import { useCurrentClientUserStore } from '@client/entity/current-client-user/application/store/current-client-user.store';
import type { CurrentClientUserStoreQuery } from '@client/entity/current-client-user/domain/store/current-client-user.store-query';
import type { CurrentClientUserStoreCommand } from '@client/entity/current-client-user/domain/store/current-client-user.store-command';
import type { CurrentClientUserClient } from '@client/entity/current-client-user/domain/model/current-client-user-client.model';
import type { CurrentUserStoreResetter } from '@shared/entity/current-user/domain/service/current-user-store-resetter.service';
import type { CurrentClientUser } from '@client/entity/current-client-user/domain/model/current-client-user.model';

@injectable()
export class CurrentClientUserPiniaStoreAdapter
  implements CurrentClientUserStoreQuery, CurrentClientUserStoreCommand, CurrentUserStoreResetter
{
  private readonly store = useCurrentClientUserStore();

  public getSelectedClient(): CurrentClientUserClient | null {
    return this.store.selectedClient;
  }

  public getDefinedSelectedClient(): CurrentClientUserClient {
    return this.store.definedSelectedClient;
  }

  public getSelectedClientId(): string | null {
    return this.store.selectedClient?.id ?? null;
  }

  public getDefinedSelectedClientId(): string {
    return this.store.definedSelectedClient.id;
  }

  public getCurrentClientUser(): CurrentClientUser | null {
    return this.store.currentClientUser;
  }

  public getDefinedCurrentClientUser(): CurrentClientUser {
    return this.store.definedCurrentClientUser;
  }

  public getDefinedCurrentClientUserClients(): CurrentClientUserClient[] {
    return this.store.definedCurrentClientUser.clients;
  }

  public setCurrentClientUser(user: CurrentClientUser | null): void {
    this.store.setCurrentClientUser(user);
  }

  public setSelectedClient(client: CurrentClientUserClient): void {
    this.store.setSelectedClient(client);
  }

  public clearSelectedClient(): void {
    this.store.clearSelectedClient();
  }

  public setLoading(loading: boolean): void {
    this.store.setLoading(loading);
  }

  public reset(): void {
    this.store.reset();
  }
}
